<template>
    <div class="record">
        <div class="record_view">
            <div class="record_number">粤ICP备2022086636号-1</div>
        </div>
    </div>
</template>

<script>
export default {
    name:"Record"
}
</script>

<style scoped>
.record_view{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
    color: rgb(118, 144, 144);
    background: rgb(43,45,69);
}
.record_number{
    font-size: 13px;
}
</style>